import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import dayjs from 'dayjs';
import { getCourses } from '../../../../redux/features/crmSlice';
import GlobalTable from '../../../../components/CustomTableWithPagination/GlobalTable';
import GlobalWrapper from '../../../../components/Wrapper/GlobalWrapper';
import GlobalSelectFieldWithoutFormikNew from '../../../../components/mui/GlobalSelectFieldWithoutFormikNew';
import { MONTHS_WITHOUT_ALL } from '../../../../utils/courseIncome/constaints';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { croAnalyticsTableHeader } from './utils/croAnalyticsTableHeader';
import { getCroAnalyticsTable } from '../../../../redux/features/crdMigrationSlice';

export default function CroPerfomanceAnalytics() {
  // normal variable
  const dispatch = useDispatch();

  // Redux State-------------------------------------------------------------
  //
  const loading = useSelector((state) => state.crdMigration.croAnalyticsTable.loading);
  const croAnalyticsTable = useSelector((state) => state.crdMigration.croAnalyticsTable.data);
  const meta = useSelector((state) => state.crdMigration.croAnalyticsTable.meta);
  const coursesPreData = useSelector((state) => state.crm.coursesPreData);
  const courseLoading = useSelector((state) => state.crm.loading);
  //
  //--------------------------------------------------------------------------

  // react state
  const [month, setMonth] = useState({ id: dayjs().month() + 1, value: '' });
  const [year, setYear] = useState(dayjs().year());
  const [course, setCourse] = useState({ courseId: '', courseName: '' });
  const [tableState, setTableState] = useState({
    page: 1,
    pageSize: 50,
    search: '',
    sort: { field: '', direction: 'asc' },
    frozenColumns: [],
    hiddenColumns: [],
  });

  // EXCEPT CRO ---------------------------------------------
  useEffect(() => {
    dispatch(getCourses());
  }, [dispatch]);
  // ---------------------------------------------------------

  //---------- DispatchParams ---------------------------------
  const dispatchParams = useMemo(
    () => ({
      year,
      month: month?.id,
      course_id: course?.courseId === -1 ? null : course?.courseId,
      page: tableState?.page,
      limit: tableState?.pageSize,
      search: tableState?.search,
      sortBy: tableState?.sort?.field,
      sortDirection: tableState?.sort?.direction,
    }),
    [year, month, tableState?.page, tableState?.search, tableState?.sort, tableState?.pageSize, course],
  );

  //---------* =-=-=-==-=--=-=-=-=- *---------------------------

  //-------------- Table Fetch ------------------------------
  useEffect(() => {
    dispatch(getCroAnalyticsTable(dispatchParams));
  }, [dispatchParams, dispatch]);
  //-------------* Table Fetch *-----------------------------

  return (
    <GlobalWrapper title={'CRO Analytics'}>
      <Stack gap={2}>
        <Stack direction={{ xs: 'column', sm: 'row' }} gap={1}>
          <GlobalSelectFieldWithoutFormikNew
            data={MONTHS_WITHOUT_ALL}
            keys={{
              itemId: 'id',
              itemValue: 'name',
            }}
            label={'Months'}
            selectedDetails={month}
            setChange={setMonth}
            sx={{
              maxWidth: { xs: '100%', sm: 180 },
            }}
          />
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label={'Year'}
              views={['year']}
              onChange={(v) => setYear(v?.year() ? v?.year() : dayjs().year())}
              value={dayjs().year(year)}
              sx={{
                maxWidth: { xs: '100%', sm: 180 },
              }}
            />
          </LocalizationProvider>

          <Autocomplete
            id="combo-box-demo"
            getOptionLabel={({ courseName }) => courseName ?? ''}
            isOptionEqualToValue={(opt, val) => opt?.courseId === val?.courseId}
            options={coursesPreData ?? []}
            onChange={(_, v) => setCourse(v)}
            sx={{ minWidth: { xs: '100%', sm: 300 } }}
            renderInput={(params) => <TextField {...params} label="Course" />}
            loading={courseLoading}
          />
        </Stack>
        <GlobalTable
          rowUniqueId="sl_no"
          headers={croAnalyticsTableHeader}
          tableState={tableState}
          setTableState={setTableState}
          loading={loading}
          rows={croAnalyticsTable}
          showOnlyRecords
          meta={meta}
        />
      </Stack>
    </GlobalWrapper>
  );
}
